export default {
    approvalInquiry: 'Approval Onsite',
    approvalLeave: 'Approval Leave',
    typeInquiry: 'Type Inquiry',
    status: 'Status',
    allType: 'All Type',
    employeeNo: 'Employee No',
    name: 'Name',
    date: 'Date',
    leaveType: 'Leave Type',
    description: 'Reason',
    approve: 'Approve',
    reject: 'Reject',
    personalLeave: 'personal leave',
    sickLeave: 'sick leave',
    onSite: 'onsite',
    allTypeMessage: 'leave and onsite',
    inquiryMessageType: 'There is no $type request of date ',
    msgSuccess: 'Save success',
    requireRemark: 'Remark is required',
    cannotGetLineId: 'Cannot get line user id'
}
